/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Container
{
  constructor (cursor)
  {
    this.cursor = cursor;
  }


  unload (key)
  {
    this.cursor.child(key).remove();
  }


  has (key)
  {
    return this.cursor.child(key).has();
  }


  size ()
  {
    return this.getState().size;
  }


  keys ()
  {
    return this.getState().keySeq().toArray();
  }


  values ()
  {
    return this.keys().map(key => this.at(key));
  }


  flatMap (callback)
  {
    return this.values().flatMap(callback);
  }


  getState ()
  {
    return this.cursor.get();
  }


};
